import styled from 'styled-components';
import { Paper } from '@material-ui/core';

export const StyledPaper = styled(Paper)`
  && {
    position: relative;
    color: #000000;
    background: rgba(177, 225, 89, 0.6);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
`;